import { axiosInstance, requestConfig } from 'network/apis';

import { URL_ITEM } from 'utils/constants';

export const callItemNotification = async () => {
    return await axiosInstance(requestConfig('get', URL_ITEM, '/item/getnotification'));
};
